module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-julia.37e5b0a5.jpeg";